import ManualHeader from './ManualHeader';

export default ManualHeader;
